<template>
  <div
    class="tw-rounded-xl tw-bg-neutral-900 tw-p-6 tw-text-white tw-shadow-sm"
  >
    <div class="tw-space-y-6">
      <QuotesIcon class="tw-w-14" />
      <blockquote class="tw-text-lg tw-font-semibold lg:tw-text-2xl">
        “{{ testimonial.content }}”
      </blockquote>
      <div
        class="tw-flex tw-flex-col tw-justify-between tw-space-y-6 lg:tw-flex-row lg:tw-items-center lg:tw-space-y-0"
      >
        <div
          class="tw-flex tw-flex-col tw-space-y-4 md:tw-flex-row md:tw-items-center md:tw-space-x-3 md:tw-space-y-0"
        >
          <div class="tw-flex tw-items-center tw-space-x-3">
            <Avatar
              :src="testimonial.avatarUrl"
              size="lg"
              class="tw-shrink-0"
            />
            <div>
              <div class="tw-font-bold">{{ testimonial.author }}</div>
              <div class="tw-text-sm tw-font-medium tw-text-neutral-400">
                {{ testimonial.position }}
              </div>
            </div>
          </div>
          <img :src="testimonial.companyUrl" alt="" class="tw-w-24" />
        </div>
        <div>
          <button
            class="tw-inline-flex tw-items-center tw-rounded-full tw-border-2 tw-border-white tw-bg-transparent tw-px-4 tw-py-3 tw-text-xl tw-font-semibold tw-text-white focus:tw-outline-none focus-visible:tw-ring focus-visible:tw-ring-neutral-500"
            @click="handleGetStartedClick"
          >
            Get Started
            <ArrowRight class="tw-ml-2 tw-h-4 tw-w-4" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import QuotesIcon from '@/assets/images/icons/quotes.svg'
import ArrowRight from '@/assets/images/icons/arrow-right.svg'
import { UNLOCK_FULL_ACCESS_MODAL_NAME } from '@/shared/data/globalVariables.js'
import Avatar from '@/shared/components/avatar/Avatar.vue'
import { ACCESS_TYPE, ROLE } from '@/shared/data/permissionSystem.js'
import { router, usePage } from '@inertiajs/vue3'
import { computed } from 'vue'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'
import { useModals } from '@/shared/composables/useModals.js'

const page = usePage()
const { hasRole, hasAccess } = usePermissionSystem()
const { openModal } = useModals()

const testimonial = computed(() => page.props.testimonial)

const handleGetStartedClick = () => {
  if (hasRole(ROLE.GUEST) || hasAccess(ACCESS_TYPE.NONE)) {
    return openModal(UNLOCK_FULL_ACCESS_MODAL_NAME)
  }
}
</script>
